import {createSelector} from 'reselect';
import props from '../../props';

export default createSelector(
    props.tournaments.tournament_timestamp,
    props.user.isAuth,
    (timestamp, isAuth) => {
        return {
            timestamp,
            isAuth
        }
    }
)